import { api } from "@/lib/pos-api";
import { getActiveStore } from './scope';

export const purchaseDraftPrefix = (tenantId, userId) =>
  `pos_purchase_draft:v2:${tenantId}:${userId}:${getActiveStore()}:`;

export function readLocalPurchaseDrafts(prefix) {
  const drafts = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!key?.startsWith(prefix)) continue;
    try {
      const draft = JSON.parse(localStorage.getItem(key));
      if (draft?.version === 1 && draft.id && key === prefix + draft.id && typeof draft.updatedAt === "string" && Array.isArray(draft.lines)) drafts.push(draft);
    } catch { /* A damaged entry must not hide other recoverable drafts. */ }
  }
  return drafts.sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
}

export function backupPurchaseDraft(prefix, draft) {
  localStorage.setItem(prefix + draft.id, JSON.stringify({ ...draft, version: 1, updatedAt: new Date().toISOString() }));
}

export function removeLocalPurchaseDraft(prefix, id) {
  localStorage.removeItem(prefix + id);
}

const migrations = new Map();
export async function readPurchaseDrafts(prefix) {
  if (migrations.has(prefix)) return migrations.get(prefix);
  const pending = (async () => {
    const recovered = [];
    let warning = "";
    let local = [];
    try { local = readLocalPurchaseDrafts(prefix); } catch { /* Server storage works without local storage. */ }
    try {
      const parts = prefix.split(':');
      const legacy = readLocalPurchaseDrafts(`pos_purchase_draft:${parts[2]}:${parts[3]}:`);
      if (legacy.length) warning = 'Ada salinan draf lokal versi lama tanpa penanda cabang. Data tetap disimpan; hubungi admin untuk rekonsiliasi. Draf server cabang ini tetap tersedia di bawah.';
    } catch { /* Never discard an unreadable legacy copy. */ }
    for (const draft of local) {
      const before = localStorage.getItem(prefix + draft.id);
      try {
        if (draft.revision == null) await api.post(`/purchase-drafts/${draft.id}/import`, draft);
        else await api.put(`/purchase-drafts/${draft.id}`, draft);
        if (localStorage.getItem(prefix + draft.id) === before) removeLocalPurchaseDraft(prefix, draft.id);
      } catch {
        warning = "Ada isian lokal yang belum tersinkron. Lanjutkan salinan pemulihan untuk menyimpannya sebagai draf baru.";
        recovered.push({ ...draft, id: crypto.randomUUID(), revision: 0, recoverySourceId: draft.id });
      }
    }
    const { data } = await api.get("/purchase-drafts");
    return { drafts: [...recovered, ...data], warning };
  })();
  migrations.set(prefix, pending);
  try { return await pending; } finally { migrations.delete(prefix); }
}

export async function writePurchaseDraft(draft, revision) {
  const { data } = await api.put(`/purchase-drafts/${draft.id}`, { ...draft, revision });
  return data;
}

export async function removePurchaseDraft(draft) {
  await api.delete(`/purchase-drafts/${draft.id}`, { params: { revision: draft.revision } });
}
